import _ from 'lodash'

export const icon = 'handshake'
export const humanName = {
  singular: 'Parceiro',
  plural: 'Parceiros'
}
export const getConfig = props => {
  const { digitalProductId } = props

  const basePath = '/parceiros'
  const apiBasePath = `/user/digital_products/${digitalProductId}/partners`
  const getBreadcrumbs = (breadcrumbs = []) => [
    {
      href: basePath,
      name: humanName.plural
    },
    ...breadcrumbs
  ]
  const config = {
    basePath,
    apiBasePath,
    icon,
    humanName,
    getBreadcrumbs,
    sort: {
      field: 'position',
      order: 'asc'
    },
    pagination: { perPage: 999 },
    useRecordsConfig: {
      options: {
        keepPreviousData: true
      }
    }
  }

  return config
}
